import loadable from '@loadable/component';


export default loadable(() => import(/* webpackChunkName: "searchListing.m" */ './SearchListing'));
